<template>
  <div>
    <h1>Ladda ner rapporter</h1>
    <p>
      Här laddar du ner rapporter över försäljning, utfall, nyttjandegrad osv.
      Börja med att välja vilken rapport du vill ladda ner, och filtrera sedan
      på period. Klicka tillsut på Ladda ner rapport.
    </p>

    <div
      style="float: left; width: 100%; margin-bottom: 45px; margin-top:20px;"
    >
      <div
        class="btn btn-info"
        v-bind:class="{ active: filter.type == 'salesByLocation' }"
        v-on:click="setFilterType('salesByLocation')"
      >
        Försäljning per location
      </div>

      <div
        class="btn btn-info"
        v-bind:class="{ active: filter.type == 'salesByLocationMonthly' }"
        v-on:click="setFilterType('salesByLocationMonthly')"
      >
        Försäljning per location & månad (aktiva/inaktiva)
      </div>

      <div
        class="btn btn-info"
        v-bind:class="{ active: filter.type == 'outcomeAndUtilization' }"
        v-on:click="setFilterType('outcomeAndUtilization')"
      >
        Utfall & nyttjandegrad
      </div>

      <div
        class="btn btn-info"
        v-bind:class="{ active: filter.type == 'treatments' }"
        v-on:click="setFilterType('treatments')"
      >
        Utförda behandlingar
      </div>

      <div
        class="btn btn-info"
        v-bind:class="{ active: filter.type == 'affiliateInvoices' }"
        v-on:click="setFilterType('affiliateInvoices')"
      >
        Faktureringsunderlag inköpskanaler
      </div>

      <div
        class="btn btn-info"
        v-bind:class="{ active: filter.type == 'cardsByUser' }"
        v-on:click="setFilterType('cardsByUser')"
      >
        Redovisning för klippkortsarbetare
      </div>

      <div
        class="btn btn-info"
        v-bind:class="{ active: filter.type == 'treatmentsByClinic' }"
        v-on:click="setFilterType('treatmentsByClinic')"
      >
        Behandlingar partner
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'incrementalUtilization' }"
        v-on:click="setFilterType('incrementalUtilization')"
      >
        Månadsfördelning nyttjande
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'smsFeedback' }"
        v-on:click="setFilterType('smsFeedback')"
      >
        Kundenkät - alla svar
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{
          active: filter.type == 'cardsIncreaseOrDecreasePunches'
        }"
        v-on:click="setFilterType('cardsIncreaseOrDecreasePunches')"
      >
        Kort med minskade och ökade klipp samt intäkt
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'residualIncome' }"
        v-on:click="setFilterType('residualIncome')"
      >
        Utgångna klipp med restintäkt
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'extendedDurations' }"
        v-on:click="setFilterType('extendedDurations')"
      >
        Förlängda kort
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'multipleTreatments' }"
        v-on:click="setFilterType('multipleTreatments')"
      >
        Dubbla registreringar
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'bonuses' }"
        v-on:click="setFilterType('bonuses')"
      >
        Extra ersättningar & bonusar
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'accrued' }"
        v-on:click="setFilterType('accrued')"
      >
        Upplupna ännu ej redovisade intäkter
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'smsSales' }"
        v-on:click="setFilterType('smsSales')"
      >
        Skickade sms om att klipp är slut
      </div>

      <div
        class="btn btn-info"
        style="margin-top: 5px;"
        v-bind:class="{ active: filter.type == 'bookingTimes' }"
        v-on:click="setFilterType('bookingTimes')"
      >
        Tider i bokningskalendrar
      </div>
    </div>

    <div style="float: left; width: 100%; margin-bottom: 25px;">
      <div v-if="filter.type == 'salesByLocation'">
        <p>Period avser kortets försäljnigsdatum</p>
        <p>Bara de locations med försäljning dyker upp i excelen</p>
      </div>

      <div v-if="filter.type == 'outcomeAndUtilization'">
        <p>Period avser kortets försäljnigsdatum</p>
      </div>

      <div v-if="filter.type == 'treatments'">
        <p>Period avser behandlingsdatum</p>
        <p>Location filtret gäller behandlingslocation</p>
      </div>

      <div v-if="filter.type == 'incrementalUtilization'">
        <p>Period avser kortets försäljnigsdatum</p>
      </div>

      <div v-if="filter.type == 'bookingTimes'">
        <p>Inga filter har effekt på denna rapport. Rapporten visar alltid senast inlästa bokningstider.</p>
      </div>
    </div>

    <div style="float: left; width: 100%; margin-bottom: 25px;">
      <div
        style="float: left;"
        v-bind:style="{ width: widths[0], marginRight: marginRight }"
      >
        <h4>Välj period</h4>
      </div>

      <div
        v-if="
          filter.type != 'cardsByUser' &&
            filter.type != 'treatmentsByClinic' &&
            filter.type != 'cardsIncreaseOrDecreasePunches' &&
            filter.type != 'bonuses' &&
            filter.type != 'multipleTreatments' &&
            filter.type != 'smsFeedback'
        "
      >
        <div
          style="float: left;"
          v-bind:style="{ width: widths[1], marginRight: marginRight }"
        >
          <h4>
            Försäljningskanaler
            <span
              style="font-size: 12px; margin-top: 4px; float: right; cursor: pointer;"
              v-on:click="modeToggle('affiliates')"
              v-html="modeText('affiliates')"
            ></span>
          </h4>
        </div>

        <div
          style="float: left;"
          v-bind:style="{ width: widths[2], marginRight: marginRight }"
        >
          <h4>
            Produkter
            <span
              style="font-size: 12px; margin-top: 4px; float: right; cursor: pointer;"
              v-on:click="modeToggle('products')"
              v-html="modeText('products')"
            ></span>
          </h4>
        </div>

        <div style="float: left;" v-bind:style="{ width: widths[3] }">
          <h4>
            Locations
            <span
              style="font-size: 12px; margin-top: 4px; float: right; cursor: pointer;"
              v-on:click="modeToggle('addresses')"
              v-html="modeText('addresses')"
            ></span>
          </h4>
        </div>
      </div>

        <div v-else-if="filter.type === 'smsFeedback'">
            <div
                style="float: left;"
                v-bind:style="{ width: widths[1], marginRight: marginRight }"
            >
                <h4>
                    Tjänsteområde
                    <span
                        style="font-size: 12px; margin-top: 4px; float: right; cursor: pointer;"
                        v-on:click="modeToggle('productAreas')"
                        v-html="modeText('productAreas')"
                    ></span>
                </h4>
            </div>
        </div>

        <div v-else>
        <div
          style="float: left;"
          v-bind:style="{ width: widths[1], marginRight: marginRight }"
          v-if="
            filter.type != 'cardsIncreaseOrDecreasePunches' &&
              filter.type != 'bonuses'
          "
        >
          <h4>
            Användare
            <span
              style="font-size: 12px; margin-top: 4px; float: right; cursor: pointer;"
              v-on:click="modeToggle('users')"
              v-html="modeText('users')"
            ></span>
          </h4>
        </div>
      </div>
    </div>

    <div style="float: left; width: 100%;">
      <div
        style="float: left; height: 230px;"
        v-bind:style="{ width: widths[0], marginRight: marginRight }"
      >
        <new-datepicker
          :format="dateFormat"
          v-model="filter.from"
          language="sv"
          input-class="form-control"
          placeholder="Från"
          :monday-first="true"
          :clear-button="true"
        >
        </new-datepicker>

        <br />

        <new-datepicker
          :format="dateFormat"
          v-model="filter.to"
          language="sv"
          input-class="form-control"
          placeholder="Till"
          :monday-first="true"
          :clear-button="true"
        >
        </new-datepicker>

        <br />

        <!--
			<select v-model="filter.year" class="form-control" style="margin-bottom: 15px;">
				<option v-bind:value="''">Välj år</option>
				<option v-for="year in years">{{ year }}</option>
			</select>

			<select v-model="filter.month" class="form-control" style="margin-bottom: 15px;">
				<option v-bind:value="''">Välj månad</option>
				<option v-for="month in months">{{ month }}</option>
			</select>
			-->

        <label v-if="filter.type == 'outcomeAndUtilization'">
          <input type="checkbox" v-model="filter.only_expired" /> Bara utgångna
          kort
        </label>

        <label v-if="filter.type == 'outcomeAndUtilization'">
          <input type="checkbox" v-model="filter.only_non_expired" /> Bara EJ
          utgångna kort
        </label>

        <label
          v-if="
            filter.type == 'salesByLocation' ||
              filter.type == 'salesByLocationMonthly'
          "
        >
          <input type="checkbox" v-model="filter.include_no_sales" /> Ta med
          även de som ännu inte haft försäljning
        </label>
      </div>

      <div
        v-if="
          filter.type != 'cardsByUser' &&
            filter.type != 'treatmentsByClinic' &&
            filter.type != 'bonuses' &&
            filter.type != 'multipleTreatments' &&
            filter.type != 'smsFeedback'
        "
      >
        <div
          style="float: left; height: 500px; padding:10px; border:1px solid #dcdcdc; overflow-y: scroll;"
          v-bind:style="{ width: widths[1], marginRight: marginRight }"
          v-if="modeState.affiliates == 1"
        >
          <div style="margin-bottom: 15px;">
            <span
              style="cursor: pointer;"
              v-on:click="massToggle('affiliates')"
              class="excel-markall"
            >{{ toggleText("affiliates") }}</span
            >
          </div>
          <div v-for="affiliate in affiliates">
            <label
            ><input
              type="checkbox"
              v-model="filter.affiliates"
              v-bind:value="affiliate.id"
            />
              {{ affiliate.name }}</label
            >
          </div>
        </div>
        <div
          style="float: left; padding: 10px;"
          v-bind:style="{ width: widths[1], marginRight: marginRight }"
          v-else
        ></div>

        <div
          style="float: left; height: 500px; padding:10px; border:1px solid #dcdcdc; overflow-y: scroll;"
          v-bind:style="{ width: widths[2], marginRight: marginRight }"
          v-if="modeState.products == 1"
        >
          <div style="margin-bottom: 15px;">
            <span
              style="cursor: pointer;"
              v-on:click="massToggle('products')"
              class="excel-markall"
            >{{ toggleText("products") }}</span
            >
          </div>
          <div v-for="product in products">
            <label
            ><input
              type="checkbox"
              v-model="filter.products"
              v-bind:value="product.id"
            />
              {{ product.name }}</label
            >
          </div>
        </div>
        <div
          style="float: left; padding: 10px;"
          v-bind:style="{ width: widths[2], marginRight: marginRight }"
          v-else
        ></div>

        <div
          style="float: left; height: 500px; padding:10px; border:1px solid #dcdcdc; overflow-y: scroll;"
          v-bind:style="{ width: widths[3] }"
          v-if="modeState.addresses == 1"
        >
          <div style="margin-bottom: 15px;">
            <span
              style="cursor: pointer;"
              v-on:click="massToggle('addresses')"
              class="excel-markall"
            >{{ toggleText("addresses") }}</span
            >
          </div>
          <div v-for="address in addresses">
            <label
            ><input
              type="checkbox"
              v-model="filter.addresses"
              v-bind:value="address.id"
            />
              {{ address.title }}</label
            >
          </div>
        </div>
        <div
          style="float: left; padding: 10px;"
          v-bind:style="{ width: widths[3], marginRight: marginRight }"
          v-else
        ></div>
      </div>

        <div v-else-if="filter.type === 'smsFeedback'">
            <div
                style="float: left; height: 500px; padding:10px; border:1px solid #dcdcdc; overflow-y: scroll;"
                v-bind:style="{ width: widths[1], marginRight: marginRight }"
                v-if="modeState.productAreas == 1"
            >
                <div style="margin-bottom: 15px;">
            <span
                style="cursor: pointer;"
                v-on:click="massToggle('productAreas')"
                class="excel-markall"
            >{{ toggleText("productAreas") }}</span
            >
                </div>
                    <div>
                        <label>
                            <input
                            type="checkbox"
                            v-model="filter.productAreas"
                            :value="1"
                        />
                            Massage
                        </label>
                    </div>

                    <div>
                        <label>
                            <input
                            type="checkbox"
                            v-model="filter.productAreas"
                            :value="2"
                        />
                            PT
                        </label>
                    </div>

            </div>
            <div
                style="float: left; padding: 10px;"
                v-bind:style="{ width: widths[1], marginRight: marginRight }"
                v-else
            ></div>
        </div>

      <div v-else>
        <div
          style="float: left; height: 500px; padding:10px; border:1px solid #dcdcdc; overflow-y: scroll;"
          v-bind:style="{ width: widths[1], marginRight: marginRight }"
          v-if="modeState.users == 1 && filter.type != 'bonuses'"
        >
          <div style="margin-bottom: 15px;">
            <span
              style="cursor: pointer;"
              v-on:click="massToggle('users')"
              class="excel-markall"
            >{{ toggleText("users") }}</span
            >
          </div>
          <div v-for="user in users">
            <label
            ><input
              type="checkbox"
              v-model="filter.users"
              v-bind:value="user.id"
            />
              {{ user.name }}</label
            >
          </div>
        </div>
        <div
          style="float: left; padding: 10px;"
          v-bind:style="{ width: widths[1], marginRight: marginRight }"
          v-else
        ></div>
      </div>
    </div>

    <div style="float: left; width: 100%; margin-top: 10px;">
      <button
        class="btn btn-primary pull-right"
        v-on:click="report()"
        v-if="!loading"
      >
        Ladda ner rapport
      </button>
      <button class="btn pull-right" v-if="loading">
        Genererar rapport...
      </button>
    </div>

</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
    components: {
        newDatepicker: Datepicker
    },
    props: {
        affiliates: {},
        products: {},
        addresses: {},
        users: {}
    },
    data () {
        return {
            loading: false,

            filter: {
                type: 'salesByLocation',
                from: '',
                to: '',
                affiliates: [],
                products: [],
                addresses: [],
                users: [],
                productAreas: [],
                only_expired: false,
                only_non_expired: false,
                include_no_sales: false
            },

            modeState: {
                affiliates: 0,
                products: 0,
                addresses: 0,
                users: 0,
                productAreas: 0
            },

            toggleState: {
                affiliates: 0,
                products: 0,
                addresses: 0,
                users: 0
            },

            dateFormat: 'yyyy-MM-dd',

            marginRight: '3.3%',
            widths: ['15%', '30%', '15%', '30%']
        }
    },
    computed: {
        years () {
            let start = 2015
            const end = moment().format('YYYY')

            const years = {}

            while (start <= end) {
                years[start] = start

                start++
            }

            return years
        },
        months () {
            let start = 1
            const end = 12

            const months = {}

            while (start <= end) {
                months[start] = start

                start++
            }

            return months
        }
    },
    methods: {
        report () {
            const self = this

            if (self.filter.type !== 'bookingTimes' && (!self.filter.from || !self.filter.to)) {
                alert('Du måste välja från och till datum')
                return
            }

            self.loading = true

            const newFilter = []

            _.forEach(self.filter, function (value, key) {
                if (key == 'from' || key == 'to') {
                    value = moment(value).format('YYYY-MM-DD')
                }

                newFilter[key] = value
            })

            const query = Object.keys(newFilter)
                .map(
                    key =>
                        `${encodeURIComponent(key)}=${encodeURIComponent(newFilter[key])}`
                )
                .join('&')

            // window.location.href = '/reports/download?'+query;

            const new_window = window.open(
                '/reports/download/' + self.filter.type + '?' + query
            )

            // w.addEventListener('onbeforeunload', self.stopLoader());

            new_window.onbeforeunload = function () {
                self.loading = false
            }
        },

        setFilterType (type) {
            this.filter.only_expired = false
            this.filter.type = type
        },

        massToggle (type) {
            const self = this

            self.filter[type] = []

            if (self.toggleState[type] == 0) {
                _.forEach(self[type], function (value, key) {
                    console.log(key)

                    self.filter[type].push(value.id)
                })
            }

            self.toggleState[type] = 1 - self.toggleState[type]
        },

        modeToggle (type) {
            const self = this

            self.filter[type] = []

            self.modeState[type] = 1 - self.modeState[type]
        },

        modeText (type) {
            const self = this

            if (self.modeState[type] == 0) {
                return '(<b>Alla</b> / Filter)'
            }

            return '(Alla / <b>Filter</b>)'
        },

        toggleText (type) {
            const self = this

            if (self.toggleState[type] == 0) {
                return 'Markera alla'
            }

            return 'Avmarkera alla'
        }
    }
}
</script>
